import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import { AxiosError } from "axios";
import {
  LoginApiResponse,
  LoginParams,
  LoginState,
  LoginErrorApiResponse,
} from "./LoginType";
import { RootState } from "../../redux/store";

//ログイン時の非同期API連携
export const fetchAsyncLogin = createAsyncThunk<
  LoginApiResponse,
  LoginParams,
  { rejectValue: LoginErrorApiResponse }
>("login/post", async ({ email, password }, { rejectWithValue }) => {
  try {
    const res = await axiosSettings.post<LoginApiResponse>("api/login", {
      email,
      password,
    });
    return res.data;
  } catch (error: any) {
    return rejectWithValue(error.response.data);
  }
});
//初期state
const initialState: LoginState = {
  user: "",
  loginSuccess: false,
  msg: "",
  email: "",
  loading: false,
};

//slice
export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    editUserId(state, action) {
      state.user = action.payload;
    },
    //emailだけstoreで管理
    editEmail(state, action) {
      state.email = action.payload;
    },
    //ログアウト機能
    logout(state) {
      state.user = "";
      state.loginSuccess = false;
    },
    //ログイン時validation
    setError(state, action) {
      state.msg = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncLogin.fulfilled, (state, action) => {
      state.loading = false;
      //ログイン成功
      if (action.payload.status === "Success") {
        sessionStorage.setItem(
          "token",
          action.payload.data.result!.access_token
        );
        state.loginSuccess = true;
        state.msg = "";
      }
      //ログイン失敗
      else {
        state.msg = action.payload.data.message!;
      }
    });
    builder.addCase(fetchAsyncLogin.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncLogin.rejected, (state, action) => {
      state.loading = false;
      if (action.payload!.data.code === "E10400") {
        state.msg = "パスワードが違います。";
      }
      if (action.payload!.data.code === "E00000") {
        state.msg = "適正なメールアドレスを入力してください。";
      }
    });
  },
});

export const userId = (state: RootState) => state.login.user;
export const userEmail = (state: RootState) => state.login.email;
export const errorMsg = (state: RootState) => state.login.msg;
export const loginJudge = (state: RootState) => state.login.loginSuccess;
export const loading = (state: RootState) => state.login.loading;
export const { editEmail, editUserId, logout, setError } = loginSlice.actions;
export default loginSlice.reducer;
